module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/core-js/library/modules/_add-to-unscopables.js
// module id = 809
// module chunks = 1